import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AdminLayout.css";

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="currentColor"/>
        </svg>
      ),
      path: "/admin"
    },
    {
      id: "products",
      label: "Products",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" fill="none" stroke="currentColor" strokeWidth="2"/>
          <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2"/>
          <path d="M16 10a4 4 0 0 1-8 0" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/products"
    },
    // {
    //   id: "variants",
    //   label: "Product Variants",
    //   icon: (
    //     <svg viewBox="0 0 24 24">
    //       <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/>
    //       <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
    //     </svg>
    //   ),
    //   path: "/admin/variants"
    // },
    {
      id: "orders",
      label: "Orders",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M16 11V7a4 4 0 0 0-8 0v4" fill="none" stroke="currentColor" strokeWidth="2"/>
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/orders"
    },
    {
      id: "users",
      label: "Users",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" fill="none" stroke="currentColor" strokeWidth="2"/>
          <circle cx="9" cy="7" r="4" fill="none" stroke="currentColor" strokeWidth="2"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/users"
    },
    {
      id: "categories",
      label: "Categories",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M4 7h16v10H4z" fill="none" stroke="currentColor" strokeWidth="2"/>
          <path d="M4 9l8 5 8-5" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/categories"
    },
    {
      id: "subcategories",
      label: "Subcategories",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" fill="currentColor"/>
        </svg>
      ),
      path: "/admin/subcategories"
    },
    {
      id: "brands",
      label: "Brands",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/>
        </svg>
      ),
      path: "/admin/brands"
    },
    {
      id: "zones",
      label: "Zones",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="none" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 6v6l4 2" fill="none" stroke="currentColor" strokeWidth="2"/>
          <path d="M8 12h8" fill="none" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 8v8" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/zones"
    },
    {
      id: "banners",
      label: "Banners",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M4 16l4.586-4.586a2 2 0 0 1 2.828 0L16 16m-2-2l1.586-1.586a2 2 0 0 1 2.828 0L20 14m-6-6h.01M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/banners"
    },
    {
      id: "pages-banners",
      label: "Pages Banners",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.586a1 1 0 0 1-.293.707l-6.414 6.414a1 1 0 0 0-.293.707V17l-4 4v-6.586a1 1 0 0 0-.293-.707L3.293 7.293A1 1 0 0 1 3 6.586V4z" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/pages-banners"
    },
    {
      id: "contact-info",
      label: "Contact Info",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/contact-info"
    },
    {
      id: "newsletter-subscriptions",
      label: "Newsletter Subscriptions",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" fill="none" stroke="currentColor" strokeWidth="2"/>
          <polyline points="22,6 12,13 2,6" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/newsletter-subscriptions"
    },
    {
      id: "offers",
      label: "Offers",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/>
          <path d="M9 12l2 2 4-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      path: "/admin/offers"
    },
    {
      id: "offer-sections",
      label: "Offer Sections",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M4 16l4.586-4.586a2 2 0 0 1 2.828 0L16 16m-2-2l1.586-1.586a2 2 0 0 1 2.828 0L20 14m-6-6h.01M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      path: "/admin/offer-sections"
    },
    {
      id: "reviews",
      label: "Reviews",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/>
        </svg>
      ),
      path: "/admin/reviews"
    }
  ];

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("user_role");
    navigate("/");
  };

  const isActive = (path) => {
    if (path === "/admin") {
      return location.pathname === "/admin";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <div className="logo">
            <h2>MARIAMLY</h2>
            <span className="admin-badge">Admin</span>
          </div>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          >
            <svg viewBox="0 0 24 24">
              <path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {menuItems.map((item) => (
              <li key={item.id}>
                <button
                  className={`nav-item ${isActive(item.path) ? "active" : ""}`}
                  onClick={() => navigate(item.path)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {!sidebarCollapsed && <span className="nav-label">{item.label}</span>}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {user.fname?.[0]?.toUpperCase() || "A"}
            </div>
            {!sidebarCollapsed && (
              <div className="user-details">
                <div className="user-name">{user.fname} {user.lname}</div>
                <div className="user-role">Administrator</div>
              </div>
            )}
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <svg viewBox="0 0 24 24">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" fill="none" stroke="currentColor" strokeWidth="2"/>
              <polyline points="16,17 21,12 16,7" fill="none" stroke="currentColor" strokeWidth="2"/>
              <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2"/>
            </svg>
            {!sidebarCollapsed && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
}
